import { Button } from "components/DesignSystem/Button/Button";
import { DeleteIcon } from "components/icons/delete";
import { EntityBoxHeader } from "../EntityBoxHeader";
import ToolTip from "components/design/toolTip";
import { QuestionMarkCircle } from "components/icons/QuestionMarkCircle";
import { Divider } from "components/design/Divider";
import { DnDArea } from "components/design/UploadFileSection";

type SelectionModeProps = {
  disableDelete: boolean;
  onDelete: () => void;
  onUpload: (file: File) => void;
  onEnterManually: () => void;
};

export const SelectionMode = ({
  disableDelete,
  onDelete,
  onUpload,
  onEnterManually,
}: SelectionModeProps) => {
  const handleFileUpload = (files: File[]) => {
    if (files.length > 0) {
      onUpload(files[0]);
    }
  };
  return (
    <div className="t-border t-border-solid t-border-neutral-10 t-rounded-lg t-p-6">
      <div className="t-flex t-items-center t-justify-between t-mb-4">
        <EntityBoxHeader />
        {!disableDelete && (
          <Button
            type="button"
            customType="ghost"
            onClick={onDelete}
            size="small"
            leftIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        )}
      </div>
      <div className="t-flex t-justify-end t-mb-1">
        <ToolTip
          text={
            <div className="t-text-center t-w-72">
              Your COI is the legal proof of your company's formation. It
              confirms your official name, entity type, and state of
              incorporation. We use it to automatically set up your U.S. entity
              without manual entry.
            </div>
          }
        >
          <div className="t-flex t-items-center">
            <QuestionMarkCircle className="t-text-neutral-40" />
            <div className="t-text-caption t-italic t-text-neutral-40 t-font-thin">
              Why do we need this?
            </div>
          </div>
        </ToolTip>
      </div>
      <DnDArea
        multiple={false}
        onDrop={handleFileUpload}
        accept={{ "application/pdf": [".pdf"] }}
        subText="Upload Certificate of Incorporation"
        hideIcon
        hideTitle
      />

      <div className="t-my-4 t-flex t-items-center t-justify-between t-gap-2 t-w-2/3 t-mx-auto">
        <Divider classNames="t-w-full" />
        <span className="t-text-body-sm t-text-text-30">or</span>
        <Divider classNames="t-w-full" />
      </div>

      <Button
        type="button"
        customType="primary_outlined"
        onClick={onEnterManually}
        block
      >
        Enter details manually
      </Button>
    </div>
  );
};
